module.exports = __webpack_public_path__ + "img/blueAssigned.e8656c1d.svg";